import FilterBooleanState from '@features/categories/mobx/state/FilterBooleanState';
import FilterMultiselectState from '@features/categories/mobx/state/FilterMultiselectState';
import FilterInputState from '@features/categories/mobx/state/FilterInputState';
import FilterSelectState from '@features/categories/mobx/state/FilterSelectState';
import FilterRangeState from '@features/categories/mobx/state/FilterRangeState';
import FilterSortState from '@features/categories/mobx/state/FilterSortState';

// eslint-disable-next-line import/prefer-default-export
export const getSelectedFilters = (filtersIterator: string[], filters: Map<string, FilterMultiselectState | FilterRangeState | FilterSortState | FilterBooleanState>): string[] => filtersIterator.filter(filterName => {
  const filter = filters.get(filterName);
  if (filter instanceof FilterBooleanState && filter.value.length) return true;
  if (filter instanceof FilterMultiselectState && filter.value.length) return true;
  if ((filter instanceof FilterInputState || filter instanceof FilterSelectState) && filter.value) return true;
  if (filter instanceof FilterRangeState) {
    const {
      value
    } = filter;
    const {
      defaultValue
    } = filter;
    if (value.min !== defaultValue.min || value.max !== defaultValue.max) return true;
  }
  return false;
});